/**
 * Tenant (company) identifiers used for per-tenant behavior in the CMS.
 *
 * Tenant-specific behavior is gated at runtime on the logged-in user's
 * `company.id`, so a single shared build can serve every tenant.
 */

/** Arcadehal (Pop Culture Arcade). */
export const ARCADEHAL_COMPANY_ID = '019ec5c9-467e-7e09-9b75-bceab43bfb81';

/** Eropuitje: staging and production are different company rows. */
export const EROPUITJE_COMPANY_IDS = [
  '01978c44-8f99-721b-a896-43df85594e0d',
  '019c9db6-92f5-716e-ab35-7cc7a0310272',
];

/** Smashroom (Rage Room Smash It). Production only, no staging row. */
export const SMASHROOM_COMPANY_ID = '01a07fbe-b35d-77d0-9524-896a25eb40df';

const TIERED_PRICING_COMPANY_IDS = [
  ...EROPUITJE_COMPANY_IDS,
  SMASHROOM_COMPANY_ID,
];

/**
 * Age group and group size pricing are enabled per company (Eropuitje and
 * Smashroom). Gates the activity Pricing tab and every booking read of the
 * product's tiers, so a tier configured on another company is ignored rather
 * than charged. Keep in sync with `tieredPricing` in the widget's
 * `src/tenants/*.ts`.
 */
export const hasTieredPricing = (companyId: string | undefined) =>
  !!companyId && TIERED_PRICING_COMPANY_IDS.includes(companyId);
